import React, { useState } from "react";
import { useNavigate} from "react-router-dom";
import {
	Box,
	Button,
	Container,
	Typography,
	Divider,
	TextField,
	Autocomplete,
	Chip,
	InputAdornment,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	IconButton,
} from "@mui/material";

import { useAuth } from "../../helpers/AuthProvider";
import queryGraphql from "../../helpers/ApiInterface";
import { ExpandMore } from "@mui/icons-material";
import MainDrawer from "../MainDrawer";
import ServiceRequestsTable from "./ServiceRequestsTable";
import MiniBot from "../MiniBot";
interface SearchOptions {
	chipLabel: string;
	dropdownLabel: string;
	category: string;
	groupBy: string;
}

let searchOptions: SearchOptions[] = [];
const ServiceRequestsPage: React.FC = () => {
	const [services, setServices] = useState([]);
	const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
	const [updates, setUpdates] =  useState<any>([]);
	const navigate = useNavigate();
	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							currentStatus
							resourceId
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);	

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
                        services {
						id,
                        serviceName,
						
                        serviceOwner{
                        id,
                        name,
                        email,
                        googleProfilePicture,
                        },
                        actionedAt,
                        reasonForRejection,
                        serviceApprover{
                        id,
                        name,
                        email,
                        googleProfilePicture,
                        },
                        application{
                        id,
                        applicationName
                        }
                        createdAt,
                        status
                        }
                        }
					`);

				let servicesArr = data.services?.map((e: any) => {
					return {
						...e,

						serviceOwnerAvatar: e?.serviceOwner?.googleProfilePicture,
						serviceOwner: e?.serviceOwner?.name,
						serviceApproverAvatar: e?.serviceApprover?.googleProfilePicture,
						serviceApprover: e?.serviceApprover?.name,
						createdAt: new Date(Number(e.createdAt)).toISOString(),
						actionedAt: new Date(Number(e.actionedAt)).toISOString(),
					};
				});
				setServices(servicesArr);
				searchOptions = servicesArr
					.map((e: any) => {
						return [
							{
								category: "serviceName",
								groupBy: "SERVICE NAME",
								chipLabel: `Service Name: ${e.serviceName}`,
								dropdownLabel: e.serviceName,
							},

							{
								category: "serviceOwner",
								groupBy: "OWNER",
								chipLabel: `Owner: ${e.serviceOwner}`,
								dropdownLabel: e.serviceOwner,
							},
							{
								category: "serviceApprover",
								groupBy: "ACTIONED BY",
								chipLabel: `Actioned By: ${e.serviceApprover}`,
								dropdownLabel: e.serviceApprover,
							},
						];
					})
					.flat();
				console.log("HERE");
				console.log(searchOptions);
				searchOptions = searchOptions.filter(
					(obj, index, self) =>
						index ===
						self.findIndex(
							(t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
						)
				);
				searchOptions.sort((a, b) => {
					if (a.groupBy > b.groupBy) return 1;
					if (a.groupBy < b.groupBy) return -1;
					if (a.dropdownLabel > b.dropdownLabel) return 1;
					if (a.dropdownLabel < b.dropdownLabel) return -1;
					return 0;
				});

				// setUsers(result.data.users);
				// setLoading(false);
			} catch (error) {
				// setError(error.message);
				// setLoading(false);
				console.log(error);
			}
		};

		fetchData();
	}, []);

	const filteredServices =
		searchQuery.length == 0
			? services
			: services.filter(
					(service: any) =>
						(searchQuery.filter((e) => e.category == "serviceName").length > 0
							? searchQuery
									.filter((e) => e.category == "serviceName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.serviceName?.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "serviceOwner").length > 0
							? searchQuery
									.filter((e) => e.category == "serviceOwner")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.serviceOwner?.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "serviceApprover").length > 0
							? searchQuery
									.filter((e) => e.category == "serviceApprover")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.serviceApprover?.toLowerCase())
							: true)
			  );
	const filteredActiveServices = filteredServices.filter(
		(service: any) => service.status === "active" 
	);
	const filteredPendingServices = filteredServices.filter(
		(service: any) => service.status === "pending" 
	);
	const filteredRejectedServices = filteredServices.filter(
		(service: any) => service.status === "rejected" 
	);

	return (
		<Box sx={{ display: "flex" }}>
			<MainDrawer index={"requests-service"} />
			<MiniBot/>
			<Box
				component="main"
				// display="inline-block"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",

					minHeight: window.innerHeight,
				}}
			>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="#FFFFFF" p={2} mb="18px">
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginY: 1,
								marginLeft: 2,
							}}
						>
							<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
								Requests
							</Typography>
							<IconButton
																	  aria-label="Help" 
																	  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
																	  sx={{
																		padding: 0, 
																		border: 'none',  
																		mr:2,
																		'&:hover': {
																		  
																		  backgroundColor: 'action.hover', 
																		},
																		
																	  }}
																	>
																	  <Box
																		component="img"
																		src="/assets/Help.svg" 
																		alt="" 
																		sx={{
																		  width: 40,  
																		  height: 40,
																		  display: 'block', 
																		}}
																	  />
																	</IconButton>
						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box
							sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mx: 2 }}
						>
							<Box>
								<Typography
									fontFamily="Gilroy-SemiBold"
									fontSize="16px"
								>{`SERVICES (${services.length})`}</Typography>
								<Typography
									fontFamily="Gilroy-Regular"
									fontSize="14px"
								>{`View all the requests raised by the developers`}</Typography>
							</Box>
							<Autocomplete
								multiple
								options={searchOptions}
								filterSelectedOptions
								getOptionLabel={(option) => option.dropdownLabel}
								defaultValue={[]}
								groupBy={(option) => option.groupBy}
								renderTags={(tagValue, getTagProps) => {
									return tagValue.map((option, index) => (
										<Chip {...getTagProps({ index })} size="small" label={option.chipLabel} />
									));
								}}
								onChange={(e, newVal, reason) => {
									setSearchQuery(newVal);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										placeholder="Search by service name, environment, owner etc"
										fullWidth
										size="small"
										hiddenLabel
										InputProps={{
											...params.InputProps,
											startAdornment: (
												<>
													<InputAdornment position="start">
														<img
															src="/assets/search-normal.svg"
															alt="Filter Icon"
															style={{ width: "16px", paddingLeft: "4px" }}
														/>
													</InputAdornment>
													{params.InputProps.startAdornment}
												</>
											),
											disableUnderline: true,
											style: {
												backgroundColor: "#f4f4f4",
												minHeight: "45px",
												width: "500px",
												borderRadius: "8px",
												fontFamily: "Gilroy-Regular",
												fontSize: "14px",
											},
										}}
									/>
								)}
							/>
						</Box>
					</Box>
					<Box m={2}>
						<Accordion
							defaultExpanded={filteredPendingServices.length > 0 ? true : false}
							elevation={0}
							sx={{
								borderRadius: "8px",
								mb: "16px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredPendingServices.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/clock.svg"
										alt="Pending Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Pending Services ({filteredPendingServices.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredPendingServices.length > 0 && (
									<ServiceRequestsTable services={filteredPendingServices} resourceStatuses={updates} />
								)}
							</AccordionDetails>
						</Accordion>
						<Accordion
						defaultExpanded={true}
							elevation={0}
							sx={{
								borderRadius: "8px",
								mb: "16px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredActiveServices.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/tickcircle.svg"
										alt="Active Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Active Services ({filteredActiveServices.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredActiveServices.length > 0 && (
									<ServiceRequestsTable services={filteredActiveServices} resourceStatuses={updates}/>
								)}
							</AccordionDetails>
						</Accordion>

						<Accordion
							elevation={0}
							sx={{
								borderRadius: "8px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredRejectedServices.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/reject.svg"
										alt="Rejected Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Rejected Services ({filteredRejectedServices.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredRejectedServices.length > 0 && (
									<ServiceRequestsTable services={filteredRejectedServices} resourceStatuses={updates}/>
								)}
							</AccordionDetails>
						</Accordion>
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default ServiceRequestsPage;
